// extracted by mini-css-extract-plugin
export default {"grid":"LedgerSection_grid__s8NQc","head":"LedgerSection_head__JMizX","ledger":"LedgerSection_ledger__O4IsO","row":"LedgerSection_row__+KsDs","key":"LedgerSection_key__vw8Bz"};